import { CheckPromoCodeResponse } from '.'
import { makeAutoObservable, toJS } from 'mobx'

import { PagesModule } from 'shared/ui/tabs-pages'

interface PromoStore extends Record<
  PagesModule,
  CheckPromoCodeResponse | undefined
> {}

const defaultState = {
  avia: undefined,
  excursion: undefined,
  buses: undefined,
  tours: undefined,
  umrah: undefined,
  kyrgyzstan: undefined,
}

class PromoCodeStore {
  promoData: PromoStore = defaultState

  constructor() {
    makeAutoObservable(this)
  }

  setPromoCode(key: PagesModule, data: CheckPromoCodeResponse) {
    this.promoData = {
      ...this.promoData,
      [key]: data,
    }
  }

  resetPromoInfo(key: PagesModule) {
    this.promoData = {
      ...this.promoData,
      [key]: undefined,
    }
  }

  getPromoCode(key: PagesModule) {
    return toJS(this.promoData[key])
  }
}

export default new PromoCodeStore()
